import {HttpClient, HttpHeaders} from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import {StorageProvider} from './storage';
import {timeout} from 'rxjs/operators';
import {NavParamService} from './navparams';
import {Router} from '@angular/router';
import {ApiCall} from '../utils/api/apicall';
import {Constants} from '../utils/constants';
import {StringUtils} from '../utils/string.utils';
import {environment} from '../../environments/environment';
import {ApiJsonResult} from '../utils/api/apijsonresult';

export class BaseProvider {

    http: HttpClient;
    storage: StorageProvider;
    navparams: NavParamService;
    router: Router;

    constructor(http: HttpClient, storage: StorageProvider, navService: NavParamService, router: Router) {
        this.http = http;
        this.storage = storage;
        this.navparams = navService;
        this.router = router;
    }

    public callapi(call: ApiCall, apiUrl?: string) {
        const _http = this.http;
        const _router = this.router;
        const _storage = this.storage;
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(call), Constants.ENCRYPT_KEY);
        return new Promise(function(resolve, reject) {
            _storage.fetchToken().then((token: string) => {
                let headers = null;
                if (!StringUtils.isEmpty(token)) {
                    headers = new HttpHeaders().set('token', token).set('Z-App-Host', window.location.hostname);
                } else {
                    headers = new HttpHeaders().set('Z-App-Host', window.location.hostname);
                }
                if (StringUtils.isEmpty(apiUrl)) {
                    apiUrl = environment.apiUrl;
                }
                _http.post(apiUrl,
                    encrypted.toString(), {headers: headers})
                    .pipe(timeout(25000))
                    .subscribe((data: any) => {
                        const jsons = data.output.toString();
                        // const w = CryptoJS.enc.Base64.parse(encs);
                        // const jsons = CryptoJS.enc.Utf8.stringify(w);
                        const apijsonResult = ApiJsonResult.populate((JSON.parse(jsons)));
                        if (apijsonResult.status === 'ERROR') {
                            const err = {name: 'ZivroErrorResponse', message: apijsonResult.message};
                            reject(err);
                        } else if (apijsonResult.status == 'TOKEN_ERROR') {
                            _storage.removeKey('token').then(() => {
                                _router.navigateByUrl('/user/login');
                            });
                        } else {
                            if (!StringUtils.isEmpty(apijsonResult.outputparam1)) {
                                // _storage.ckie('token', apijsonResult.outputparam1);
                            }
                            resolve(apijsonResult);
                        }
                    }, (err) => {
                        console.log(err);
                        // const httpError = {name: 'ZivroErrorResponse', message: err.toString()};
                        reject(err);
                    });
            });
        });
    }

}
